import _toConsumableArray from "/var/www/vhosts/c3staalframebouw.nl/gatsby/c3staalframebouw.nl/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/www/vhosts/c3staalframebouw.nl/gatsby/c3staalframebouw.nl/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
var inputTypes = {
  website: 'url'
};
var ListField = function ListField(_ref) {
  var _ref$formik = _ref.formik,
    formik = _ref$formik === void 0 ? {} : _ref$formik,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    fieldId = _ref.fieldId,
    data = _ref.data;
  var _useFormikContext = useFormikContext(),
    handleChange = _useFormikContext.handleChange,
    handleBlur = _useFormikContext.handleBlur,
    values = _useFormikContext.values;
  var type = data.type.toLowerCase();
  var _useState = useState([{
      value: '',
      label: "".concat(fieldId, "_1"),
      id: 1
    }]),
    _useState2 = _slicedToArray(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  useEffect(function () {
    var arr = [];
    amount.forEach(function (item) {
      arr.push(values[item.label]);
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    values[fieldId] = arr;
  }, [amount, values, fieldId]);
  // Conditional logic
  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      var show = true;
      data.conditionalLogic.rules.forEach(function (rule) {
        if (rule.operator === 'IS') {
          if (values["input_".concat(rule.fieldId)] !== rule.value) {
            show = false;
          }
        }
        if (rule.operator === 'IS_NOT') {
          if (values["input_".concat(rule.fieldId)] === rule.value) {
            show = false;
          }
        }
      });
      if (!show) {
        return null;
      }
    }
  }
  return _jsxs("div", {
    className: "form-duuf-group form-duuf-group-".concat(type).concat(data.cssClass ? " ".concat(data.cssClass) : ''),
    children: [_jsx(Label, {
      fieldId: fieldId,
      data: data
    }), _jsx(Error, {
      fieldId: fieldId,
      data: data,
      hasError: hasError,
      formik: formik
    }), amount.map(function (item, index) {
      return _jsxs("div", {
        className: "flex items-center gap-3",
        children: [_jsx("input", {
          className: "form-duuf-input form-duuf-input-".concat(type),
          type: inputTypes[type] || type,
          id: item.label,
          name: item.label,
          placeholder: data.placeholder,
          onBlur: handleBlur,
          onChange: handleChange,
          value: values[item.label] || '',
          maxLength: data.maxLength === 0 ? undefined : data.maxLength
        }), index + 1 === amount.length && _jsx("div", {
          onClick: function onClick() {
            setAmount([].concat(_toConsumableArray(amount), [{
              value: '',
              label: "".concat(fieldId, "_").concat(item.id + 1),
              id: item.id + 1
            }]));
          },
          className: "form-duuf-group-".concat(type, "-add"),
          children: _jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "1.5em",
            height: "1.5em",
            viewBox: "0 0 24 24",
            children: _jsx("path", {
              fill: "currentColor",
              d: "M11 19v-6H5v-2h6V5h2v6h6v2h-6v6h-2Z"
            })
          })
        }), index > 0 && _jsx("div", {
          onClick: function onClick() {
            var newValues = amount.filter(function (_, i) {
              return i !== index;
            });
            delete values[item.label];
            setAmount(newValues);
          },
          className: "form-duuf-group-".concat(type, "-add"),
          children: _jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "1.5em",
            height: "1.5em",
            viewBox: "0 0 24 24",
            children: _jsx("path", {
              fill: "currentColor",
              d: "M19 12.998H5v-2h14z"
            })
          })
        })]
      }, index);
    })]
  });
};
export default ListField;